import { render, staticRenderFns } from "./ServicesSliderWidget.vue?vue&type=template&id=40102bee&"
import script from "./ServicesSliderWidget.vue?vue&type=script&lang=js&"
export * from "./ServicesSliderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports